module.exports = {"140226100":"云兴镇","140226101":"鹊儿山镇","140226102":"店湾镇","140226200":"管家堡乡","140226201":"张家场乡","140226205":"三屯乡","140226206":"马道头乡","140226207":"小京庄乡","140226209":"水窑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140226.json
// module id = 282
// module chunks = 0